module.exports = __webpack_public_path__ + "static/media/pp-6.47a48923.jpg";